import { CommonSuccessResponse } from "constants/types/common";
import { DebtParamsType, DebtResponseType } from "constants/types/debt";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const getDebtListKey = (params?: DebtParamsType) => {
  return `/debt?${serialize({ ...params })}`;
};

export const useDebts = (params?: DebtParamsType) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<DebtResponseType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(getDebtListKey(params), { refreshInterval: 0 });

  return {
    debts: data?.data,
    pagination: data?.meta,
    error,
    isLoading,
    mutate,
  };
};

export const useDebtDetail = (id: string | undefined) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<DebtResponseType> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(id ? `/debt/${id}` : null, {
    refreshInterval: 0,
    revalidateOnReconnect: false,
  });

  return {
    debt: data?.data,
    error,
    isLoading,
    mutate,
  };
};
